import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Offline } from 'react-detect-offline';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

// styles
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '@agrostar/normalize';
import lightTheme from '@agrostar/theme-light';
import darkTheme from '@agrostar/theme-dark';
import variables from '@agrostar/variables';

// Components
import Loader from '@agrostar/loader';
import { Toastr } from '@agrostar/toastr';
import { BackdropPortal } from '@agrostar/backdrop';
// Asych Components
const AsynchLogin = Loadable({
  loader: () => import('./routes/login/login.index'),
  loading: Loader,
});
const AsynchPostLogin = Loadable({
  loader: () => import('./routes/postLogin/postLogin.index'),
  loading: Loader,
});
const AsynchForgotPasswordStep1 = Loadable({
  loader: () => import('./routes/forgotPassword/forgotPassword.Step1.index'),
  loading: Loader,
});
const AsynchForgotPasswordStep2 = Loadable({
  loader: () => import('./routes/forgotPassword/forgotPassword.Step2.index'),
  loading: Loader,
});
class App extends Component {
  render() {
    const theme = this.props.isLight ? lightTheme : darkTheme;
    const appVariables = Object.assign({}, theme, variables);
    return (
      <ThemeProvider theme={appVariables}>
        <BrowserRouter basename="/agrowiki">
          {/* https://reacttraining.com/react-router/web/api/BrowserRouter/basename-string */}
          <div>
            {/* <Offline>
              <Toastr type="error">
                No Internet connection. Please check your internet connection
                and try again.
              </Toastr>
              <BackdropPortal />
            </Offline> */}
            <GlobalStyles />
            <Switch>
              <Route
                path="/forgotPasswordStep1"
                component={AsynchForgotPasswordStep1}
              />
              <Route
                path="/forgotPasswordStep2"
                component={AsynchForgotPasswordStep2}
              />
              <Route
                {...this.props}
                render={props =>
                  this.props.isLoggedIn ? (
                    <AsynchPostLogin {...this.props} />
                  ) : (
                    <AsynchLogin {...this.props} />
                  )
                }
              />
            </Switch>
          </div>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  isLight: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isLight: state.settings.isLight,
    isLoggedIn: state.settings.isLoggedIn,
  };
};

export default connect(
  mapStateToProps,
  null
)(App);
